import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type GeneralInformationInputFields = {
  generalInformation: string;
};

const GeneralInformationInput = ({
  generalInformationFieldConfig,
}: {
  generalInformationFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<GeneralInformationInputFields>();

  return (
    <TextArea
      label={t`Allmän information`}
      showOptionalLabel={
        generalInformationFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.generalInformation?.message}
      {...register("generalInformation", {
        required: {
          value:
            generalInformationFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange allmän information`,
        },
      })}
    />
  );
};

export default GeneralInformationInput;
